import classNames from 'classnames';
import React from 'react';
import * as styles from './Background.style.scss';

export const Background = () => {
  return <div className={classNames([styles.container])} />;
};
